import { Box, ContentBlock, Text } from 'braid-design-system';
import React from 'react';

import Section from '../Section/Section';

const Title = () => (
  <Box
    display="flex"
    background="brandAccent"
    height="touchable"
    alignItems="center"
    justifyContent="flexStart"
    width="full"
  >
    <ContentBlock>
      <Section>
        <Text>Email recommendation preferences</Text>
      </Section>
    </ContentBlock>
  </Box>
);

export default Title;
